import {Page} from '@PosterWhiteboard/page/page.class';
import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';
import {isPAYGUser} from '@Utils/user.util';
import {PAYG_LIMIT_FOR_NUM_PAGES, PREMIUM_LIMIT_FOR_NUM_PAGES} from '@PosterWhiteboard/poster/poster.class';

export const addNewPage = async (order?: number): Promise<void> => {
  if (!window.posterEditor?.whiteboard?.pages) {
    throw Error('No poster found to add page. Initialize a poster first');
  }

  const pagesInOrder = window.posterEditor.whiteboard.pages.getPagesInOrder();
  const pageOrder = order ?? pagesInOrder?.length;

  if (isPAYGUser() && pageOrder === PAYG_LIMIT_FOR_NUM_PAGES) {
    await window.PMW.showPremiumOnlyFeatureDialog(window.PMW.PREMIUM_ONLY_UNLIMITED_PAGES_FEATURE);
    return;
  }

  if (pageOrder === PREMIUM_LIMIT_FOR_NUM_PAGES) {
    return;
  }

  const page = await window.posterEditor.whiteboard.pages.addPage(
    {
      background: pagesInOrder[pageOrder - 1].background?.toObject(),
    },
    {pageOrder}
  );
  await page.poster.pages.seekToPageIndex(pageOrder);
  scrollToPage(page.hashedID);
};

export const scrollToPage = (hashedId: string): void => {
  const ANIMATION_DURATION = 300;
  const pageOffsetTop = Page.getPrePageHTMLContainerForPageId(hashedId)?.offsetTop;
  if (window.posterEditor?.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER] && pageOffsetTop) {
    window.posterEditor.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER].animate({scrollTop: pageOffsetTop}, ANIMATION_DURATION);
  }

  setTimeout((): void => {
    window.posterEditor?.whiteboard?.refreshAllVisibleCanvases();
  }, ANIMATION_DURATION);
};

export const addDuplicatedPage = async (pageToDuplicate: Page): Promise<void> => {
  const pages = window.posterEditor?.whiteboard?.pages;
  if (!pages) {
    throw Error('No poster found to add page. Initialize a poster first');
  }

  const duplicatedPageObject = pageToDuplicate.getDuplicatedPageObject();
  const pageOrder = (pages.getPageOrder(pageToDuplicate.hashedID) ?? 0) + 1;

  const page = await pages.addPage(duplicatedPageObject, {pageOrder});
  void page.poster.pages.seekToPageIndex(pageOrder);

  scrollToPage(page.hashedID);
};
